<template>
  <Map
    v-if="state"
    ref="mapRef"
    :map-style="jobSearchGlobal.config.map.mapStyle.value"
    @bounds-changed="onBoundsChanged"
    @map-moved="hasMapMoved = true"
  >
    <template v-if="state.items.length > 0">
      <MapMarker
        v-for="marker in resolvedMarkers"
        :key="marker.coordinate.join('-')"
        :lng-lat.camel="marker.coordinate"
        :items-count="marker.items.length"
        :computed-function="computed"
        @click="focusOnClickedItem(marker)"
      >
        <MarkerContent
          :items="marker.items"
          :job-search-global="jobSearchGlobal"
          @item-clicked="handleItemClicked"
          @slide-changed="$emit('slide-changed', $event)"
        />
      </MapMarker>
    </template>
  </Map>
</template>

<script>
// Import for vue 3
import { createWidgetMixin } from "vue-instantsearch/vue3/es";
import { computed } from "vue";

import { connectGeoSearch } from "instantsearch.js/es/connectors";

import {
  searchMapComponents,
  searchMapInject,
  searchMapData,
  searchMapComputed,
  searchMapWatch,
  searchMapMethods,
} from "./mixins/searchMap.js";

export default {
  name: "SearchMapVue3",
  mixins: [
    createWidgetMixin({ connector: connectGeoSearch }),
    searchMapComponents,
    searchMapInject,
    searchMapData,
    searchMapComputed,
    searchMapWatch,
    searchMapMethods,
  ],
  emits: ["item-clicked", "slide-changed", "marker-clicked"],
  methods: {
    computed,
    handleItemClicked(event) {
      this.$emit("item-clicked", event);
      this.state.sendEvent("click", event, "Item Clicked");
    },
  },
};
</script>
